<template>
  <div class="bankmanage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />

    <Masterfund @rowdata="rowdata" :files="files" />
    <!-- <Examinelist v-if="margintap == 1" @rowdata="rowdata" :files="files" @auditlistNub='auditlistNub' /> -->
  </div>
</template>

<script>
import * as api from "@/api/fund/masterfund";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Masterfund from "./components/masterfundindex";
// import Examinelist from "./components/examinelist";
import { mapGetters } from "vuex";
export default {
  name: "bankmanage",
  data() {
    return {
      margintap: 0,
      examinelist: 0,
      form: [],
      files: [], 
    };
  },
  components: {
    TagsCloud,
    Masterfund
  },
  computed: {
    ...mapGetters(["permission"])
  },
  created() {
    // this.onload();
  },
  methods: {
    // onload() {
    //   api
    //     .getList({
    //       firstNum: 0,
    //       num: 10,
    //       auditState:1
    //     })
    //     .then(res => {
    //       console.log(res);
    //       this.examinelist = res.data.data.total;
 
    //     })
    //     .catch(res => {
    //       console.log(res);
    //     });
    // },

    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },
    auditlistNub(data){
      
      this.examinelist=data
    },
    cloudTages(data) {
      this.files = data;
      console.log(this.files);
      // this.$emit("cloudTages", data);
    }
  }
};
</script>
<style lang="scss" scoped>
.bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      // font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  /deep/.el-badge__content{
  line-height: 17px;
    padding: 0 5px;
  }
}
/deep/.el-table__footer-wrapper,/deep/.el-table__fixed-footer-wrapper {
   .cell {
      color:red
    }
 }
</style>
